export enum EmailTemplateEnum {
  SignUpTemplate = 1,
  ResetPasswordLink = 2,
  SendResetPasReReRwordLinkInMail = 3,
  AssingReviewArticle = 4,
}
export default EmailTemplateEnum;
